// for a reference of BCP locale codes, see
//  https://www.iana.org/assignments/language_subtag_registry/language_subtag_registry

const localeMappingData: Array<{
  /**
   * The locale code as defiend in BCP47
   */
  bcp: string;
  /**
   * The locale code as used by the Amadeus SI / OBEs
   */
  si: string;
  /**
   * Specifies if this entry is a secondary resolution for the gicen SI locale.
   * Avoids confusion between i.e. uk and uk_ua as the resolution for UK.
   */
  secondary?: boolean;
  /**
   * Specifies the locale code in the angular common module.
   * Needs to resolve to a file when inserted in @angular/common/locales/${ngLocaleFilename}.js
   * See https://github.com/angular/angular/tree/master/packages/common/locales to find a listing.
   */
  ngLocaleFilename: string;
}> = [
  // Portugese
  {
    bcp: 'pt_BR',
    si: 'BR',
    ngLocaleFilename: 'pt'
  },
  {
    bcp: 'br',
    si: 'BR',
    secondary: true,
    ngLocaleFilename: 'pt'
  },
  // German
  {
    bcp: 'de_DE',
    si: 'DE',
    ngLocaleFilename: 'de'
  },
  {
    bcp: 'de',
    si: 'DE',
    secondary: true,
    ngLocaleFilename: 'de'
  },
  {
    bcp: 'de_AT',
    si: 'DE',
    secondary: true,
    ngLocaleFilename: 'de'
  },
  // English - British
  {
    bcp: 'en_GB',
    si: 'GB',
    ngLocaleFilename: 'en-GB'
  },
  {
    bcp: 'en',
    si: 'GB',
    secondary: true,
    ngLocaleFilename: 'en-GB'
  },
  // English - United States
  {
    bcp: 'en_US',
    si: 'US',
    ngLocaleFilename: 'en'
  },
  // Spanish
  {
    bcp: 'es_ES',
    si: 'ES',
    ngLocaleFilename: 'es'
  },
  {
    bcp: 'es',
    si: 'ES',
    secondary: true,
    ngLocaleFilename: 'es'
  },
  // French
  {
    bcp: 'fr_FR',
    si: 'FR',
    ngLocaleFilename: 'fr'
  },
  {
    bcp: 'fr',
    si: 'FR',
    secondary: true,
    ngLocaleFilename: 'fr'
  },
  // Japanese
  {
    bcp: 'ja_JP',
    si: 'JP',
    ngLocaleFilename: 'ja'
  },
  {
    bcp: 'ja',
    si: 'JP',
    secondary: true,
    ngLocaleFilename: 'ja'
  },
  // Korean
  {
    bcp: 'ko',
    si: 'KO',
    ngLocaleFilename: 'ko'
  },
  // Russian
  {
    bcp: 'ru_RU',
    si: 'RU',
    ngLocaleFilename: 'ru'
  },
  {
    bcp: 'ru',
    si: 'RU',
    secondary: true,
    ngLocaleFilename: 'ru'
  },
  // Ukrainian
  {
    bcp: 'uk_UA',
    si: 'UK',
    ngLocaleFilename: 'uk'
  },
  {
    bcp: 'uk',
    si: 'UK',
    secondary: true,
    ngLocaleFilename: 'uk'
  },
  // Turkish
  {
    bcp: 'tr_TR',
    si: 'TK',
    ngLocaleFilename: 'tr'
  },
  {
    bcp: 'tr',
    si: 'TK',
    secondary: true,
    ngLocaleFilename: 'tr'
  },
  // Simplified Chinese
  {
    bcp: 'zh_CN',
    si: 'CN',
    ngLocaleFilename: 'zh'
  },
  {
    bcp: 'zh_Hans_CN',
    si: 'CN',
    secondary: true,
    ngLocaleFilename: 'zh'
  },
  // Taiwanese Chinese
  {
    bcp: 'zh_TW',
    si: 'TW',
    ngLocaleFilename: 'zh-Hant'
  },
  {
    bcp: 'zh_Hant_TW',
    si: 'TW',
    secondary: true,
    ngLocaleFilename: 'zh-Hant'
  },
  // Italian
  {
    bcp: 'it_IT',
    si: 'IT',
    ngLocaleFilename: 'it'
  },
  {
    bcp: 'it',
    si: 'IT',
    secondary: true,
    ngLocaleFilename: 'it'
  },
  // Indonesian - Indonesia
  {
    bcp: 'id_ID',
    si: 'ID',
    ngLocaleFilename: 'id'
  },
  {
    bcp: 'id',
    si: 'ID',
    secondary: true,
    ngLocaleFilename: 'id'
  }
];

export const siLocaleToBcp: Map<string, string> = new Map(
  localeMappingData.filter(entry => !entry.secondary).map(entry => [entry.si.toUpperCase(), entry.bcp])
);

export const bcpLocaleToSi: Map<string, string> = new Map(
  localeMappingData.map(entry => [entry.bcp.toLowerCase(), entry.si])
);

export const bcpLocaleToNgFilename: Map<string, string> = new Map(
  localeMappingData.map(entry => [entry.bcp.toLowerCase(), entry.ngLocaleFilename])
);
